<form *ngIf="form" [formGroup]="form">
  <mat-card appearance="outlined" class="center-content">
    <div>
      <h2>
        {{ wasteProfile?.name }} - [

        {{ wasteProfile?.number }} ]
      </h2>
    </div>
    <div class="column-2">
      <div class="col">
        <div class="input-container">
          <label> Waste Profile Status</label>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-select formControlName="status">
              <mat-option
                *ngFor="let option of statusOptions.options"
                [value]="option"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="input-container">
          <label> Customer Name </label>
          <mat-form-field appearance="outline">
            <input maxlength="64" matInput formControlName="customerName" />
          </mat-form-field>
          <mat-error *ngIf="errorHandling('customerName', 'required')">
            Customer Name is <strong>Required</strong>
          </mat-error>
        </div>

        <div class="input-container">
          <label> Approved Date </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              [matDatepicker]="picker1"
              formControlName="approvedDate"
              #pickerInput1
              placeholder="MM/DD/YYYY"
              (dateChange)="resetBadRawDateInput('approvedDate', pickerInput1)"
            />
            <mat-datepicker-toggle
              matPrefix
              [for]="picker1"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <mat-error class="error" *ngIf="errorHandling('approvedDate', 'max')">
            Invalid Date
          </mat-error>
          <mat-error class="error" *ngIf="errorHandling('approvedDate', 'min')">
            Invalid Date
          </mat-error>
        </div>
        <div class="input-container">
          <label> Expiry Date </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              [matDatepicker]="picker2"
              formControlName="expiryDate"
              #pickerInput2
              placeholder="MM/DD/YYYY"
              (dateChange)="resetBadRawDateInput('expiryDate', pickerInput2)"
            />
            <mat-datepicker-toggle
              matPrefix
              [for]="picker2"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
          <mat-error class="error" *ngIf="errorHandling('expiryDate', 'max')">
            Invalid Date
          </mat-error>
          <mat-error class="error" *ngIf="errorHandling('expiryDate', 'min')">
            Invalid Date
          </mat-error>
        </div>
        <div class="input-container">
          <label> Submitted Date </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              [matDatepicker]="picker3"
              formControlName="submittedDate"
              #pickerInput3
              placeholder="MM/DD/YYYY"
              (dateChange)="resetBadRawDateInput('submittedDate', pickerInput3)"
            />
            <mat-datepicker-toggle
              matPrefix
              [for]="picker3"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker3></mat-datepicker>
          </mat-form-field>
          <mat-error
            class="error"
            *ngIf="errorHandling('submittedDate', 'max')"
          >
            Invalid Date
          </mat-error>
          <mat-error
            class="error"
            *ngIf="errorHandling('submittedDate', 'min')"
          >
            Invalid Date
          </mat-error>
        </div>
      </div>
      <div class="col">
        <div class="input-container">
          <label>Internal Waste Profile Status</label>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-select formControlName="internalStatus">
              <mat-option
                *ngFor="let option of internalStatusOptions.options"
                [value]="option"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="input-container">
          <label> Sales Rep Name </label>

          <digital-platform-sales-rep-drop-down
            formControlName="salesRep"
          ></digital-platform-sales-rep-drop-down>
        </div>
        <div class="input-container">
          <label> Coordinators </label>
          <digital-platform-coordinators-drop-down
            formControlName="coordinator"
          >
          </digital-platform-coordinators-drop-down>
        </div>
        <div class="input-container">
          <label> Analyst Name </label>

          <digital-platform-analysts-drop-down
            formControlName="approverName"
          ></digital-platform-analysts-drop-down>
        </div>
      </div>
    </div>
    <div class="input-container">
      <label>Approval Notes</label>
      <mat-form-field appearance="outline">
        <textarea
          formControlName="approvalNotes"
          matInput
          matTextareaAutosize
          matAutosizeMinRows="10"
          matAutosizeMaxRows="8"
        ></textarea>
      </mat-form-field>
    </div>
  </mat-card>
  <br />
  <mat-card appearance="outlined" class="center-content">
    <ng-container>
      <h2>Generator</h2>
      <digital-platform-add-generator-form
        formControlName="generator"
        displayMode="admin"
        [profileStatus]="profileStatus"
        [isLegacy]="isLegacy"
      ></digital-platform-add-generator-form>
    </ng-container>
  </mat-card>
  <br />

  <mat-card appearance="outlined" class="center-content">
    <ng-container>
      <h2>Billing</h2>
      <digital-platform-generator-billing-form
        [profileStatus]="profileStatus"
        formControlName="billing"
        [isLegacy]="isLegacy"
      >
      </digital-platform-generator-billing-form>
    </ng-container>
  </mat-card>
  <br />

  <mat-card appearance="outlined" class="center-content">
    <ng-container>
      <digital-platform-waste-stream-form
        formControlName="wasteStream"
        [profileStatus]="profileStatus"
        [isLegacy]="isLegacy"
      ></digital-platform-waste-stream-form>
    </ng-container>
  </mat-card>
  <br />
  <mat-card appearance="outlined" class="center-content">
    <ng-container>
      <digital-platform-physical-characteristics
        formControlName="physicalComponent"
        [profileStatus]="profileStatus"
        [isLegacy]="isLegacy"
      >
      </digital-platform-physical-characteristics>
    </ng-container>
  </mat-card>
  <br />

  <mat-card appearance="outlined" class="center-content">
    <ng-container>
      <digital-platform-disposal-destination
        formControlName="destination"
        [profileStatus]="profileStatus"
      ></digital-platform-disposal-destination>
    </ng-container>
  </mat-card>
  <br />
  <mat-card appearance="outlined" class="center-content">
    <ng-container>
      <digital-platform-regulatory-questions
        formControlName="regulatoryQuestions"
        [profileStatus]="profileStatus"
        [isLegacy]="isLegacy"
      >
      </digital-platform-regulatory-questions>
    </ng-container>
  </mat-card>
  <br />
  <mat-card appearance="outlined" class="center-content">
    <label> Signature Info </label>
    <div formArrayName="signatures">
      <div
        class="input-container"
        *ngFor="let class of form.get('signatures')?.controls; index as i"
        [formGroupName]="i"
      >
        <div class="column-2">
          <div class="col">
            <div class="input-container">
              <label> Company Name </label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="company" />
              </mat-form-field>
            </div>
            <div>
              <label> Name </label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="name" />
              </mat-form-field>
            </div>

            <div class="input-container">
              <label> Signed Date </label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  [matDatepicker]="picker4"
                  formControlName="date"
                />
                <mat-datepicker-toggle
                  matPrefix
                  [for]="picker4"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker4></mat-datepicker>
              </mat-form-field>
            </div>
          </div>

          <div class="col">
            <div class="input-container">
              <label> Email </label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="email" />
              </mat-form-field>
              <mat-error *ngIf="signatureErrorHandling('email', 'email', i)">
                Please enter a valid email address
              </mat-error>
            </div>
            <div class="input-container">
              <label> Title </label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="title" />
              </mat-form-field>
            </div>

            <div class="input-container">
              <label>Is Signed </label>
              <mat-radio-group fxLayout="column" formControlName="isSigned">
                <mat-radio-button [value]="true">Yes</mat-radio-button>
                <mat-radio-button [value]="false">No</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
  <digital-platform-sw-wizard-navigation
    [nextLabel]="'Save'"
    (back)="onBack()"
    (next)="onNext()"
    [nextDisabled]="disableButtons"
    [backDisabled]="disableButtons"
  ></digital-platform-sw-wizard-navigation>
</form>
